import { z } from 'zod';
import { benefitStatusEnum } from '../enums';
import { paginationQuerySchema, slugSchema, urlSchema } from './common';

// Concept Partners — each concept curates its own partner directory (parts
// suppliers, brands, services). Partners are shown on the member benefits page
// and advertise BONUS points: spend with a partner earns extra points per £1.
// (Display + seam now; real accrual arrives with the external spend API, like
// the mocked spend in the rewards feature.)
export const createPartnerSchema = z.object({
  name: z.string().trim().min(2).max(120),
  slug: slugSchema.optional(),
  description: z.string().trim().max(1000).nullable().optional(),
  logoUrl: urlSchema.nullable().optional(),
  websiteUrl: urlSchema.nullable().optional(),
  bonusPointsPerPound: z.number().nonnegative().max(1000).nullable().optional(),
  sortOrder: z.number().int().min(0).max(9999).optional(),
});
export type CreatePartnerPayload = z.infer<typeof createPartnerSchema>;

export const updatePartnerSchema = createPartnerSchema.partial();
export type UpdatePartnerPayload = z.infer<typeof updatePartnerSchema>;

// Lifecycle action (draft↔published↔archived), never the create payload.
export const partnerStatusActionSchema = z.object({ action: z.enum(['publish', 'archive', 'restore']) });
export type PartnerStatusAction = z.infer<typeof partnerStatusActionSchema>;

export const partnerListQuerySchema = paginationQuerySchema.extend({
  status: benefitStatusEnum.optional(),
  search: z.string().trim().max(100).optional(),
});
export type PartnerListQuery = z.infer<typeof partnerListQuerySchema>;
